import * as React from "react";

import { Button } from "../../../../Action/Button/Button";

import { ShowMoreArrowIcon } from "./TreeNode.styles";
import { useShowMoreChildren, useVisibleChildrenCount } from "./VisibleElementsCountProvider";
import { CommonTreeNodeProps } from "./utils/ITreeNodeProps";

export const useShowingMoreButton = (props: CommonTreeNodeProps, childrenCount: number) => {
    const nonVisibleChildrenCount = useNonVisibleChildrenCount(props.item.elementId, childrenCount);
    const showingMoreButton = props.nestingLevel > 1 && nonVisibleChildrenCount > 0;

    return showingMoreButton;
};

const useNonVisibleChildrenCount = (elementId: string, childrenCount: number) => {
    const visibleChildrenCount = useVisibleChildrenCount(elementId);
    const nonVisibleChildrenCount = childrenCount - visibleChildrenCount;

    return nonVisibleChildrenCount;
};

export const ShowMoreButton: React.VFC<{ elementId: string; childrenCount: number }> = ({
    elementId,
    childrenCount,
}) => {
    const showMoreChildren = useShowMoreChildren(elementId);
    const nonVisibleChildrenCount = useNonVisibleChildrenCount(elementId, childrenCount);

    return (
        <Button rightIcon={<ShowMoreArrowIcon />} use="text" onClick={showMoreChildren}>
            Показать еще {nonVisibleChildrenCount}
        </Button>
    );
};
